import React, { Component } from 'react';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { API_ENDPOINT } from '../../../constants';


class PaysonCheckTransactionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        const transactionId = this.props[0].match.params.transactionId;

        this.checkTransaction(transactionId);
    }

    checkTransaction = async (transactionId) => {
        if (!transactionId) return;

        setTimeout(() => {
            this.setState({ loading: true }, () => {
                fetch(`${API_ENDPOINT}/api/payments/payson/confirmation/transaction`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ transactionId })
                }).then(res => res.json()).then((result) => {
                    const status = result?.status ?? null;
                    this.handleCallback(status, transactionId);
                })

            });
        }, 1000);
    }
    redirectToLink = (path = '/my-data/patient/payments', state = {}) => {
        this.props[0].history.push(path, state);
    }

    handleCallback = (status, transactionId) => {
        if (!status) return;
        const checkStatuses = ['readyToPay', 'canceled', 'denied', 'readyToShip', 'shipped'];
        if (!checkStatuses.includes(status)) {
            this.checkTransaction(transactionId);
        } else {
            const isPaidSuccessfully = ['readyToShip', 'shipped'].includes(status);
            const successMessage = "Payment has been made successfully.".translate(this.props.lang);
            const failureMessage = "Payment failed, please make sure to pay before your scheduled visit.".translate(this.props.lang);
            if (isPaidSuccessfully) {
                this.redirectToLink('/my-data/patient/payments', { message: successMessage });
            } else {
                this.redirectToLink('/my-data/patient/payments', { message: failureMessage });
            }
        }
    }



    render() {
        return (
            <div className='fullscreen-loader' >
                {
                    this.state.loading ?
                        <div className="loader-wrap" >
                            <Player
                                autoplay={true}
                                loop={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                            ></Player>

                        </div>
                        :
                        null
                }

                {
                    this.props.lang && this.state.loading ?
                        <p>{"Checking transaction...".translate(this.props.lang)}</p>
                        :
                        null
                }

            </div >




        );
    }
}

export default PaysonCheckTransactionPage;